/**
 * Created by razial on 27.03.2023
 */
if (typeof cc === "undefined") {
    global.bundles.sidebar = { jsons: {} };
    global.cleverapps.config.locations = JSON.parse(require("fs").readFileSync(require("path").join(__dirname, "../../../../res/locations.json"), "utf8"));
    global.LocationConfigResolver = {
        resolve: function (id, overrides) {
            return { id, ...overrides };
        },
        resolveLocationsList: function (entries) {
            const result = {};
            entries.forEach((entry) => {
                result[entry.id] = this.resolve(entry.id, entry);
            });
            return result;
        },
        registerMissions: function () {}
    };
}

Meta.LEGACY_LOCATIONS = ["china", "adventuresp", "easter", "spring"];

Meta.GetAvailableLocations = function () {
    return LocationConfigResolver.resolveLocationsList(cleverapps.config.locations);
};

Meta.REGISTER_MISSIONS_PER_LOCATION = function () {
    LocationConfigResolver.registerMissions(Meta.GetAvailableLocations());
};

Meta.REGISTER_OFFERS_PER_LOCATION = function () {
    Object.values(Meta.GetAvailableLocations()).forEach((locationData) => {
        locationData.offers = (locationData.offers || []).map((offerData) => {
            if (typeof offerData !== "object") {
                return offerData;
            }

            const id = offerData.id;
            const baseOfferId = offerData.base;

            offerData.type = id;
            delete offerData.id;
            delete offerData.base;

            Offers[id] = { ...Offers[baseOfferId], ...offerData };

            if (baseOfferId === Offers.TYPES.SNAILFEAST) {
                Offers[id].mission = Mission.CompoundType(Mission.GetMissionType(Offers[baseOfferId].mission), locationData.id);
                cleverapps.styles.SingleProductOfferWindow[id] = cleverapps.styles.SingleProductOfferWindow[baseOfferId];
                cleverapps.styles.PackOfferComponent[id] = cleverapps.styles.PackOfferComponent[baseOfferId];
            } else if (baseOfferId === Offers.TYPES.EXPEDITION) {
                Offers[id].location = locationData.id;
                Offers[id].force = locationData.slotId === "1" ? Forces.OFFER_ICON_SLOT1 : Forces.OFFER_ICON_SLOT2;
                Offers[id].name = locationData.name.replace("Expedition", "Pack");
            }

            return id;
        });
    });
};

if (typeof cc === "undefined") {
    module.exports = Meta.GetAvailableLocations();
}
